import { useMemo } from 'react'
import { getNestedSubelementsByType } from '@fs/zion-sls'

/**
 * Custom hook to get sorted persons from the current image
 * @param {Object} currentImage - The current image object
 * @param {boolean} loading - Whether data is loading
 * @returns {Array} Array of sorted person elements
 */
export const useSortedPersons = (currentImage, loading) => {
  const sortedPersons = useMemo(() => {
    if (loading || !currentImage?.subElements) return []

    const records = currentImage.subElements
    const persons = records.reduce((acc, cur) => {
      const personElements = getNestedSubelementsByType(cur, 'PERSON')
        .filter((p) => !p.isDangling)
        .sort((a, b) => (a.primary > b.primary ? -1 : 1))
      return acc.concat(personElements)
    }, [])

    return persons || []
  }, [loading, currentImage?.subElements])

  return sortedPersons
}
